import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import UpdateOtpModalContainer from './UpdateOtpModalContainer';
import * as action from '../action';
import * as c from '../constant';

const INIT_STATE = {
  mobile_number: '',
};

function UpdateMobileNumberModal({
  updating,
  taxpayers,
  taxpayerId,
  updateMobileNumber,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(INIT_STATE);

  const validateForm = useFormValidator(formData, {
    mobile_number: 'required',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      mobile_number:
        _.get(formData, 'mobile_number') !== '63'
          ? _.get(formData, 'mobile_number')
          : '',
    };

    updateMobileNumber(taxpayerId, args, () => {
      setModal({
        isOpen: true,
        content: (
          <UpdateOtpModalContainer
            mobileNo={args.mobile_number}
            taxpayers={taxpayers}
            taxpayerId={taxpayerId}
          />
        ),
        title: 'Update Mobile Number',
        modalSize: 'modal-md',
      });
    });
  };

  const OnSetFormData = () => {
    setFormData({
      mobile_number: taxpayers.attributes.mobile_number || '',
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    OnSetFormData();
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row mx-auto">
          <div className="col-12 form-group">
            <label className="form-label">
              Mobile Number: {validateForm.renderMessage('mobile_number')}
            </label>
            <input
              className="form-control"
              type="mobile_number"
              name="mobile_number"
              placeholder="Mobile Number"
              value={_.get(formData, 'mobile_number')}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark"
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
UpdateMobileNumberModal.propTypes = {
  taxpayerId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  taxpayers: PropTypes.instanceOf(Object).isRequired,
  updateMobileNumber: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_MOBILE_NUMBER) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateMobileNumberModal);
